export default __webpack_public_path__ + "static/media/head02_zh_cn_pc@2x.67c620f4.png";